// SPDX-FileCopyrightText: (C) 2023 Jason Ish <jason@codemonkey.net>
// SPDX-License-Identifier: MIT

import "./Loader.scss";

export const Loader = () => {
  return <div class="app-loader">Loading...</div>;
};
